module.exports = __webpack_public_path__ + "static/media/edu_2.c7e4d53c.svg";